import { host } from "@Api";
import React from "react";
const { imageNew } = host;

import styles from "../../../pages/ask/price.module.less";
/** 頭部廣告信息 */
const AdvantageItem = ({ note }) => {
  return (
    <div className={styles["advantage-item"]}>
      <h3>
        推薦三家為您報價，買車更實惠
        <div className={styles["footer"]}>
          97%用戶好評：<i>服務滿分</i>
          <i>聯絡快速</i>
          <i>詳細解說</i>{" "}
        </div>
      </h3>
      <div className={styles["advantage"]}>
        <img className={styles["advantage-img"]} src={`${imageNew}/ask/img-2.png`} alt='' />
        <div className={styles["tip"]}>
          <div>
            <i className={styles["correct-icon"]} /> 省時：足不出戶，24小時內報價
          </div>
          <div>
            <i className={styles["correct-icon"]} /> 省心：個資加密，靈活取消
          </div>
          <div>
            <i className={styles["correct-icon"]} /> 省錢：專屬優惠禮包
          </div>
        </div>
      </div>
    </div>
  );
};


export default AdvantageItem